import ChargerModule from 'components/chargerModule';
import UploadQuotesModule from './UploadQuotesModuel';

const UploadQuotes = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue masivo de cotizaciones',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <UploadQuotesModule />
    </ChargerModule>
  );
};

export default UploadQuotes;
